/**
 * Banda del trámite: el mismo encabezado en todas las listas que agrupan
 * facturas por trámite (Facturas, Transit y Contabilidad).
 *
 *   Consolidado CONS-AAAAMMDD-0001 · 2 facturas · CIF total 423,744.00
 *   Trámite individual IND-AAAAMMDD-0001 · 1 factura
 *
 * El cliente pidió que todos los módulos se lean igual que Contabilidad; con
 * un solo mixin el texto no se desincroniza entre pantallas.
 *
 * Espera grupos de `invoices/getConsolidated` (GET /invoice/list-consolidated):
 * `{ type, consolidated, fdcontrolNumber, tramite, invoices }`.
 */
export default {
  methods: {
    esConsolidado(g) {
      if (!g) return false
      if (g.type) return g.type !== 'single'
      return !!g.consolidated
    },
    etiquetaTramite(g) {
      return this.esConsolidado(g) ? 'Consolidado' : 'Trámite individual'
    },
    // Consecutivo interno del trámite: CONS- en el consolidado, IND- en la
    // factura individual. Un amarre por control F&D sin fila padre (type 'fd')
    // no tiene CONS-: se muestra el control que lo agrupa. Una factura sin
    // consecutivo aún cae a su número de factura.
    consecutivoDe(g) {
      const t = (g && g.tramite) || {}
      if (this.esConsolidado(g)) {
        if (g.type === 'fd') {
          return g.fdcontrolNumber || t.invoiceNumber || '—'
        }
        return t.internalNumber || g.fdcontrolNumber || t.invoiceNumber || '—'
      }
      const first = (g && g.invoices && g.invoices[0]) || {}
      return (
        t.internalNumber ||
        first.internalNumber ||
        t.invoiceNumber ||
        first.invoiceNumber ||
        '—'
      )
    },
    facturasDe(g) {
      const n = ((g && g.invoices) || []).length
      return `${n} ${n === 1 ? 'factura' : 'facturas'}`
    },
    // El control F&D del consolidado va aparte solo cuando no es el mismo
    // texto que ya muestra la banda (amarres viejos: LN… además del CONS-).
    controlFdDe(g) {
      if (!this.esConsolidado(g) || !g.fdcontrolNumber) return null
      return g.fdcontrolNumber === this.consecutivoDe(g)
        ? null
        : g.fdcontrolNumber
    },
    // CIF del trámite: el del padre (suma de las hijas) o, si no viene, la
    // suma de las facturas del grupo.
    cifTramiteDe(g) {
      const t = (g && g.tramite) || {}
      if (t.cif !== undefined && t.cif !== null && t.cif !== '') return t.cif
      if (g && g.totals && g.totals.cif !== undefined) return g.totals.cif
      return ((g && g.invoices) || []).reduce(
        (sum, inv) => sum + (parseFloat(inv.cif) || 0),
        0
      )
    },
    // La acción del trámite va una sola vez, dentro del trámite: en un
    // consolidado es una celda que abarca todas sus facturas (rowspan) en la
    // primera fila. El cliente no quiere el botón repetido en cada factura.
    celdaTramite(g, index) {
      return !this.esConsolidado(g) || index === 0
    },
    filasTramite(g) {
      return this.esConsolidado(g) ? g.invoices.length : 1
    },
    money(value) {
      const n = parseFloat(value)
      if (Number.isNaN(n)) return '—'
      return n.toLocaleString('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      })
    },
  },
}
